<script>
    import { Spinner } from "sveltestrap";

    export let color = 'primary';

</script>

<div class="my-4 text-center">
    <Spinner {color} />
</div>
